import { AfterViewInit, Directive, EventEmitter, Input, OnInit, Output, Signal, computed, effect, signal, untracked } from '@angular/core';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { FormContainerVM, FormFieldValue, FormVMContainerDirective } from './form-vm-container.directive';
import { DatePickerComponent } from '../components/inputs/date-picker/date-picker.component';
import { RadioButtonComponent } from '../components/inputs/radio-button/radio-button.component';
import { CheckboxButtonComponent } from '../components/inputs/checkbox-button/checkbox-button.component';
import { FormControl, FormGroup } from '@angular/forms';
import { toSignal } from '@angular/core/rxjs-interop';
import { SubFormContainerDirective } from './sub-form-container/sub-form-container.directive';
import _ from 'lodash';

export type FormFieldsInputComponents =
  DatePickerComponent |
  RadioButtonComponent |
  CheckboxButtonComponent

export type FormFieldTypes = 'radio' | 'check' | 'date' | 'text' | 'yesNo'

export type ModelForFormContainer<T> = {
  name: string,
  model: T,
  type: FormFieldTypes,
  value: string | Date | null | boolean;
}

@Directive({
  selector: '[_formField]'
})
export abstract class FormField<T> implements OnInit  {

  abstract readonly type : FormFieldTypes;

  formGroup? : FormGroup

  abstract value?: string | Date | null | boolean | undefined;

  @Input() name: string = '';
  @Input() _test: string = '';
  @Input() control = new FormControl();


  modelSig = signal<T | undefined>(undefined)
  modelMap : Signal< T | string | Date | null | boolean | undefined > = computed( () => this.modelSig() )

  fieldInfoForFormContainer = computed( () => {
    const model = this.modelSig();
    const modelMap = this.modelMap()
    return {
      name: this.name,
      model,
      modelMap,
      type: this.type,
      value: this.value,
      path: this.formPath(),
      pathRaw: this.formPathRaw(),
      // pathWithVal: this.formPathPlusValue(),
      pathS: this.formPathString()
    }
  },{equal: _.isEqual})

  // modelSig = toSignal(this.control.valueChanges)

  private _model?: T;
  @Input()
  set model(value: T | undefined) {

    this.control.patchValue(value)
    this._model = value;
    this.modelSig.set(value)
  }
  get model() {
    return this._model ?? this.control.value
  }


  clearModelOnDisabled?: boolean = true;

  _disable = signal(false);
  @Input()
  set disabled(value: boolean) {
    this._disable.set(value);
    if (this._disable() ) {
      if (this.clearModelOnDisabled) {
        this.model = undefined;
      }
      this.control.disable()
    } else {
      this.control.enable()
    }

  }
  get disabled() {
    return this._disable();
  }

  formVM = signal<FormVMContainerDirective | null>(null);
  set formVMContainer(formVM: FormVMContainerDirective | null) {
    if (this.formVM() !== null || formVM == null) {
      return
    }
    this.formVM.set(formVM);
  };
  get formVMContainer() {
    return this.formVM();
  }

  formVMCurrentModel = computed( () => {
    const formVMModel = this.formVM()?.twoWayModel()
    // const model = this.modelSig()
    return formVMModel
  })

  formVMEff = effect( () => {
    if (this.type == 'radio' && this.name == 'whoInformed') {
      const modelFromGet = _.get( this.formVMCurrentModel() , this.formPath() )

      // this.model = modelFromGet
    }
    // const formModel = this.formVMCurrentModel()
    // const model = untracked(this.modelSig)



    // if (this.type == 'radio' && formModel !== undefined ) {
    //   console.log({formModel , model , name: this.name})
    // }


    // if (this.type == 'radio' &&!this.formVMCurrentModel() ) {
    //   if (this.model != this.value) {
    //     return
    //   }
    // }
    // this.model = this.formVMCurrentModel();
  }, {allowSignalWrites: true})

  parentFormVMDisabled = computed( () => {
    const formVM = this.formVM();
    if (formVM == null) {
      return false
    }
    return formVM.disableAllSig()
  })

  abstract updateModel(formVM: FormContainerVM, value: FormFieldValue) : FormContainerVM;

  calcModelForFormVM(formVM: FormContainerVM, value: ModelForFormContainer<FormFieldValue> ) {
    return value.model
  }



  private _baseParentsSubForms = signal<SubFormContainerDirective[]>([])



  formPath = computed( () => {
    const base = this._baseParentsSubForms();
    if (this.type == 'check' && this.name != 'yesNo' ) {
      return  [
        ...base
          .sort( (a,b) => a.isChild(b) )
          .map( par => par.name ) ,
        this.name,
        `${this.value!}`
      ]
    }
    return  [ ...base
      .sort( (a,b) => a.isChild(b) )
      .map( par => par.name ) , this.name
    ]
  })
  formPathRaw = computed( () => {
    const base = this._baseParentsSubForms();
    return  [ ...base
      .sort( (a,b) => a.isChild(b) )
      .map( par => par.name ) , this.name
    ]
  })

  formPathString = computed( () => {
    return this.formPath().join('$')
  })


  addParentSubForm(parentsSubForms: SubFormContainerDirective) {
    const currentP = this._baseParentsSubForms();
    const alreadyAdded = currentP.map( s => s.name ).includes(parentsSubForms.name)
    if (alreadyAdded) {
      return
    }
    this._baseParentsSubForms.set([parentsSubForms , ...currentP])
  }

  ngOnInit(): void {
    // console.log(this.control)
    // this.control.valueChanges.subscribe( value => {
    //   if (this.formVMContainer == null) {
    //     return
    //   }
    //   this.formVMContainer.containerModel.update( prevModel => {

    //     const newModel = this.updateModel(prevModel ?? {} , value)
    //     return newModel
    //   })
    // })
  }

  // updateControlDisabledStatus(){

  //   if(this._fieldDisabled || this._allFMContainerFieldsDisabled){
  //     this.control.disable();
  //   } else {
  //     this.control.enable()
  //   }
  // }


  constructor(

  ) {

   }







}

